import type { ContentBlock } from '../utils/content-block-schema'
import type { Component } from 'vue'

export type ContentBlockType = ContentBlock['paragraphType'] | '__injected_ad__' | '__injected_related__'

const CONTENT_BLOCK_COMPONENTS = {} as Record<ContentBlockType, Component>

export const registerContentBlock = (contentBlock: ContentBlockType, component: Component) => {
  CONTENT_BLOCK_COMPONENTS[contentBlock] = component
}

export const getContentBlockComponent = (contentBlock: ContentBlockType) => {
  return CONTENT_BLOCK_COMPONENTS[contentBlock]
}

/**
 * Get all registered content block types as an array of strings
 * @returns An array of all registered content block types
 */
export const getRegisteredContentBlockTypes = (): ContentBlockType[] => {
  return Object.keys(CONTENT_BLOCK_COMPONENTS) as ContentBlockType[]
}
